import { createSlice } from '@reduxjs/toolkit';

import { init } from '../resource';

import { getFaqQuestions } from './faqQuestionsThunks';
import { WidgetFaqQuestion } from './model';

export const faqQuestionsSlice = createSlice({
  name: 'faqQuestions',
  initialState: init<WidgetFaqQuestion[]>(),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      getFaqQuestions.pending,
      (state, { meta: { requestId } }) => {
        state.request = 'loading';
        state.currentRequestId = requestId;
      },
    );
    builder.addCase(
      getFaqQuestions.fulfilled,
      (state, { meta: { requestId }, payload }) => {
        if (state.currentRequestId === requestId) {
          state.value = payload;
          state.request = 'idle';
          state.currentRequestId = undefined;
        }
      },
    );
    builder.addCase(
      getFaqQuestions.rejected,
      (state, { meta: { requestId } }) => {
        if (state.currentRequestId === requestId) {
          state.request = 'error';
          state.currentRequestId = undefined;
        }
      },
    );
  },
});

export const { reducer: faqQuestionsReducer } = faqQuestionsSlice;
